/**
 * Stub for Firebase SDK entry points that `reactfire` imports unconditionally
 * but this app never uses.
 *
 * reactfire ships a single pre-bundled `dist/index.js` with static imports of
 * firebase/database, firebase/functions and firebase/storage, and declares no
 * `sideEffects: false`, so the bundler cannot drop them. That pulled ~121KB of
 * @firebase/database (plus functions + storage) into the main chunk purely to
 * support hooks we never call - see `resolve.alias` in vite.config.ts.
 *
 * Each export throws rather than returning undefined, so if someone ever does
 * start using Realtime Database, Storage or Functions they get a loud, precise
 * error at the call site instead of a mystery `undefined is not a function`.
 */

const unavailable = (name: string) => () => {
  throw new Error(
    `[firebase-unused] "${name}" is stubbed out. This app uses only Firebase ` +
      `auth, firestore, analytics and remote-config. To use Realtime Database, ` +
      `Storage or Functions, remove the matching alias in vite.config.ts.`
  );
};

// firebase/database - consumed by reactfire's useDatabaseObject/useDatabaseList
export const onChildAdded = unavailable("onChildAdded");
export const onChildRemoved = unavailable("onChildRemoved");
export const onChildChanged = unavailable("onChildChanged");
export const onChildMoved = unavailable("onChildMoved");
export const onValue = unavailable("onValue");
export const off = unavailable("off");
export const get = unavailable("get");

// firebase/functions - consumed by reactfire's useFunctions
export const httpsCallable = unavailable("httpsCallable");

// firebase/storage - consumed by reactfire's useStorageDownloadURL
export const getDownloadURL = unavailable("getDownloadURL");
export const ref = unavailable("ref");
